import { useController, type Control, type FieldValues, type Path } from 'react-hook-form'
import { Label } from '@/components/ui/label'
import { MaskedInput } from './masked-input'
import { maskPhone, stripDigits } from './masks'

interface PhoneInputProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  disabled?: boolean
}

export function PhoneInput<T extends FieldValues>({
  control,
  name,
  label = 'Telefone',
  disabled,
}: PhoneInputProps<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name })

  return (
    <div className="space-y-1.5">
      <Label htmlFor={name}>{label}</Label>
      <MaskedInput
        id={name}
        value={field.value as string ?? ''}
        onChange={field.onChange}
        mask={maskPhone}
        strip={stripDigits}
        maxRaw={11}
        placeholder="(00) 00000-0000"
        aria-invalid={!!error}
        disabled={disabled}
        onBlur={field.onBlur}
      />
      {error && <p className="text-xs text-destructive">{error.message}</p>}
    </div>
  )
}
